export const app = {
  version: "1.0.0",
  url: process.env.REACT_APP_BASE_URL
};

export const api = {
  url: process.env.REACT_APP_API_URL
};
